import { v4 } from 'uuid';
import { titleEnFromTh } from './preRegisterConfig';

const MAINTAINER_FIELDS = [1, 2, 3, 4].flatMap((n) =>
  ['name', 'surname', 'email', 'tel'].map((f) => `maintainer_${f}_${n}`)
);

// field ทั้งหมดที่ตารางสมาชิก (AddMember / AddSuccess / AddFail / HistoryDetail*) ใช้
export const MEMBER_FIELDS = [
  'employee_id', 'contract_no', 'title_th', 'title_special_th', 'special_title_th', 'special_title_eng',
  'nickname_th', 'nickname_eng', 'name_th', 'middle_name_th', 'surname_th',
  'name_eng', 'middle_name_eng', 'surname_eng',
  'cid', 'id_card_type', 'degree', 'faculty', 'major', 'minor', 'status', 'student_id', 'birth_date',
  'username', 'password',
  'address', 'house_no', 'room_no', 'moo', 'floor', 'street', 'building_name', 'alley',
  'sub_district', 'district', 'province', 'zipcode', 'start_year', 'end_year',
  'email', 'biz_email', 'position', 'department', 'sub_organization', 'organization', 'tax_id',
  ...MAINTAINER_FIELDS,
];

/**
 * แปลง 1 แถวจากไฟล์ (หรือ request เดิม) เป็นแถวของตาราง
 * แทน block ยาวๆ ที่เคยก็อปซ้ำ 3 ที่ใน AddMember (setData / setDataDefault / searchName)
 * - เก็บ key เดิมถ้ามี (ไม่สุ่มใหม่ทุกครั้งที่ redux file เปลี่ยน)
 * - tel/mobile fallback หากัน, title_en derive จาก title_th ถ้ายังไม่มี
 */
export const toMemberRow = (m = {}, index = 0) => ({
  ...Object.fromEntries(MEMBER_FIELDS.map((k) => [k, m[k]])),
  key: m.key ?? v4(),
  index: index + 1,
  tel: m.tel ?? m.mobile,
  mobile: m.mobile ?? m.tel,
  title_en: m.title_en || titleEnFromTh(m.title_th),
});

const SEARCH_FIELDS = [
  'name_th', 'name_eng', 'surname_th', 'surname_eng', 'cid', 'contract_no',
  'special_title_th', 'special_title_eng', 'nickname_th', 'nickname_eng',
  'degree', 'birth_date', 'major', 'minor', 'student_id', 'faculty', 'username', 'id_card_type',
];

/** กรองด้วย substring (ไม่สนตัวพิมพ์) ไม่ mutate แถวเดิม และเรียง index ใหม่ให้ edit ที่ใช้ index-1 ยังถูก */
export const searchRows = (rows, keyword) => {
  const q = (keyword ?? '').toString().trim().toLowerCase();
  if (!q) return rows;
  return rows
    .filter((r) => SEARCH_FIELDS.some((f) => r[f] != null && String(r[f]).toLowerCase().includes(q)))
    .map((r, i) => ({ ...r, index: i + 1 }));
};